/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/12
 * Time: 14:31
 * Desc: 分销策略设置-虚拟店长分销
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';

@Component
export default class VirtualManageDistribute extends Vue {
  /* 数据 */

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 虚拟店长分销策略列表
   * @type {number}
   */
  public distributeStrategyList: Array<DistributeStrategy> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /* 方法 */

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchDistributeStrategy() {
    this.page = 1;
    this.pageSize = 10;
    this.getDistributeStrategyList();
  }

  /**
   * 条数变更
   * @type {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getDistributeStrategyList();
  }

  /**
   * 页码变更
   * @type {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getDistributeStrategyList();
  }

  /**
   * 获取虚拟店长分销策略
   * @return null
   */
  public getDistributeStrategyList(): void {
    const queryParams = {
      page: this.page,
      pageSize: this.pageSize,
      keywords: this.keywords,
    };
    IPSService.guiderConfigList({ queryParams }).then((res) => {
      this.totalCount = res.count;
      this.distributeStrategyList = res.list;
    });
  }

  /**
   * 去往分销策略编辑和新增页面
   * @param {number|string} id
   * @return null
   */
  public onGoToDistributeStrategyEdit(id: number | string): void {
    this.$router.push(`distributeStrategySetting/edit/${id}`);
  }

  /**
   * 删除策略
   * @param {number} id
   * @return null
   */
  public onDeleteDistributeStrategy(id: number): void {
    this.$confirm('是否删除此策略?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then(() => {
      const postParams = {
        policyId: id,
      };
      IPSService.guiderConfigDelete({ postParams }).then((res) => {
        if (res) {
          this.$message.success('删除成功');
          this.getDistributeStrategyList();
        } else {
          this.$message.error('删除失败');
        }
      });
    });
  }
  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getDistributeStrategyList(); // 获取虚拟店长分销策略
  }
}
